import { ApplicationInsights, } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { connectionString } from "base-ui-generic/Common/Utils/LoggingConstants";
var reactPlugin = new ReactPlugin();
var appInsights = null;
try {
    appInsights = new ApplicationInsights({
        config: {
            connectionString: connectionString,
            extensions: [reactPlugin],
            enableAutoRouteTracking: true,
            disableAjaxTracking: false,
            autoTrackPageVisitTime: true,
            enableCorsCorrelation: true,
            enableRequestHeaderTracking: true,
            enableResponseHeaderTracking: true,
        },
    });
    appInsights.loadAppInsights();
    appInsights.addTelemetryInitializer(function (env) {
        env.tags = env.tags || [];
        env.tags["ai.cloud.role"] = "testTag";
    });
}
catch (ex) {
    console.log(ex);
}
export { reactPlugin, appInsights };
